import { Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export interface FabProps {
  onClick: () => void;
  ariaLabel: string;
  position?: "center" | "right";
  className?: string;
}

export function FAB({ onClick, ariaLabel, position = "center", className }: FabProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      style={{ viewTransitionName: "vroom-fab" }}
      className={cn(
        "fixed z-30",
        position === "center"
          ? "bottom-[calc(env(safe-area-inset-bottom)+32px)] left-1/2 -translate-x-1/2"
          : "bottom-[calc(env(safe-area-inset-bottom)+80px)] right-4",
        "inline-flex size-14 items-center justify-center rounded-full bg-p-600 text-white",
        "shadow-[0_6px_16px_rgba(20,44,84,0.30),0_2px_4px_rgba(20,44,84,0.20),inset_0_1px_0_rgba(255,255,255,0.14)]",
        "border border-p-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-p-600 focus-visible:ring-offset-2",
        "[view-transition-name:vroom-fab]",
        className,
      )}
    >
      <Plus size={28} />
    </button>
  );
}
